export const stickerSize = 80;
